import axios from '../utils/axios';

export default function findCandidate(adminId, jobId, params) {
    return (
        axios.get(`/admin/${adminId}/job/${jobId}/search-candidate`, { params })
            .then(res => {
                return res.data
            })
    )
}